import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=c87c08ae"
import script from "./PackageList.vue?vue&type=script&lang=js"
export * from "./PackageList.vue?vue&type=script&lang=js"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=c87c08ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports